/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NfcTokenUpdate
 */
export interface NfcTokenUpdate {
    /**
     * 
     * @type {string}
     * @memberof NfcTokenUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NfcTokenUpdate
     */
    userId?: string | null;
    /**
     * Normalized to lowercase by the backend.
     * @type {string}
     * @memberof NfcTokenUpdate
     */
    token?: string | null;
}

/**
 * Check if a given object implements the NfcTokenUpdate interface.
 */
export function instanceOfNfcTokenUpdate(value: object): value is NfcTokenUpdate {
    return true;
}

export function NfcTokenUpdateFromJSON(json: any): NfcTokenUpdate {
    return NfcTokenUpdateFromJSONTyped(json, false);
}

export function NfcTokenUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NfcTokenUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function NfcTokenUpdateToJSON(json: any): NfcTokenUpdate {
    return NfcTokenUpdateToJSONTyped(json, false);
}

export function NfcTokenUpdateToJSONTyped(value?: NfcTokenUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'userId': value['userId'],
        'token': value['token'],
    };
}

